<template>
  <div id="app" :class="env">
    <div class='wrapper' :class="{'block':block}">
      <app-header ref="header"/>
      <template v-if="env === 'pc'">
        <transition name="fade">
          <router-view/>
        </transition>
      </template>
      <template v-else>
        <page-a id="main" @goPage="goPage"/>
        <page-c id="world"/>
        <page-d id="war"/>
        <page-e id="class"/>
        <page-f id="media"/>
      </template>
      <app-footer/>
    </div>

    <transition name="fade">
      <popup-mov/>
    </transition>
    <transition name="fade">
      <popup-msg/>
    </transition>
    <transition name="fade">
      <popup-clause/>
    </transition>
    <transition name="fade">
      <popup-complete/>
    </transition>
    <transition name="fade">
      <popup-download/>
    </transition>

  </div>
</template>

<style src="../static/css/swiper.min.css"></style>

<script>
import $ from 'jquery';
import _ from 'lodash';
import appHeader from './components/AppHeader.vue';
import appFooter from './components/AppFooter.vue';
import store from './store';
import PopupMov from './components/PopupMov.vue';
import PageA from './views/pageA.vue';
import PageB from './views/pageB.vue';
import PageC from './views/pageC.vue';
import PageD from './views/pageD.vue';
import PageE from './views/pageE.vue';
import PageF from './views/pageF.vue';
import PopupMsg from './components/PopupMsg.vue';
import PopupClause from './components/PopupClause.vue';
import PopupComplete from './components/PopupComplete.vue';
import PopupDownload from './components/PopupDownload.vue';

export default {
  name: 'App',
  components: {
    PopupDownload,
    PopupComplete,
    PopupClause,
    PopupMsg,
    PageF,
    PageE,
    PageD,
    PageC,
    PageB,
    PageA,
    PopupMov,
    appHeader,
    appFooter,
  },
  store,
  data() {
    return {
      url: ['main', 'world', 'war', 'class', 'media'],
      ypos: null,
      win: null,
      lastId: null,
      iv: null,
      mv: null,
      isScroll: false,
      blockScroll: false,
      blockTerm: null,
    };
  },
  computed: {
    env() {
      return this.$store.state.environment;
    },
    block() {
      return this.$store.state.popupOn;
    },
  },
  watch: {
    $route() {
      this.blockScroll = true;
      clearInterval(this.blockTerm);
      this.blockTerm = setTimeout(() => {
        this.blockScroll = false;
      }, 100);
    },
  },
  methods: {
    setYv() {
      this.ypos = [];
      _.forEach(this.url, (o) => {
        this.ypos.push($(`#${o}`).offset().top);
      });
    },
    goPage($url) {
      $(document.body).css('overflow', 'hidden');
      this.$refs.header.goPage($url, true);
    },

  },
  mounted() {
    if (this.env === 'mob') {
      this.win = $(window);
      this.setYv();
      this.win.scroll(() => {
        if ($(document.body).css('overflow') === 'hidden' || this.blockScroll) return;
        clearInterval(this.iv);
        this.iv = setTimeout(() => {
          let v = _.findLastIndex(this.ypos, o => o < this.win.scrollTop() + 100);
          v = v < 0 ? 0 : v;

          if (this.lastId !== this.url[v]) {
            this.lastId = this.url[v];
            this.$router.replace(`${this.lastId}?reset=Y`);
          }
        }, 60);
      });
      this.win.resize(this.setYv);
    }
  },
};
</script>
<style lang="less">
  @import "./less/common.less";
  @import "./less/proj.less";
  #app{ .w(720);
    &.pc{
      >.wrapper{.rel; }
    }
    &.mob{
      >.wrapper{ .rel; .w(100%); .h(100%); overflow-x: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue